
import { BookYear } from "@/models/book-year";
import { BookYearService } from "@/services/book-year-service";
import Vue from "vue";
import AppCreateNewBookYearCard from "./CreateNewBookYearCard.vue";
import AppNewBookYearSuccessModal from "./NewBookyearSuccesModal.vue";


export default Vue.extend({
	data(){
		return {
			createdBookYear: null as null | BookYear,
			BookYearService,
			createOpened: false
		};
	},
	computed: {
		shouldCreateNewBookYear():boolean{
			return this.BookYearService.shouldCreateNewBookYear || this.BookYearService.manualCreateNewBookyear;
		},
	},
	watch: {
		shouldCreateNewBookYear: {
			immediate: true,
			handler(){
				if (this.shouldCreateNewBookYear){
					this.createOpened = true;
				}
			}
		}
	},
	methods: {
		onBookYearSaved(event:BookYear){
			this.createOpened = false;
			this.createdBookYear = event;
			BookYearService.selectBookYear(event);
		}
	},
	components: {
		AppCreateNewBookYearCard,
		AppNewBookYearSuccessModal
	}
});
